import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import { useSelector } from 'react-redux';
import MenuIcon from '@mui/icons-material/Menu';

const SideBar = ({setGroupCode}) => {
    const [open, setOpen] = React.useState(false);
    const {GetItemGrp} =useSelector((state) => state.itemPage);  
    // const [groupCode, setGroupCode] = React.useState("");
    const toggleDrawer = (newOpen) => () => {
      setOpen(newOpen);
    };
  
    const DrawerList = (
      <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
        <List>
            {GetItemGrp && GetItemGrp.length > 0 ? (
            GetItemGrp.map((group, index) => (
              <button
                className="categoryButton mb-auto"
                key={index}
                onClick={() => setGroupCode(group.itmsGrpCod)}
              >
                {group.itmsGrpNam}
              </button>
          ))) : (
            <p>No data available</p>
          )}
        </List>
      </Box>
    );
  
    return (
      <div className='menuIcon'>
        <Button onClick={toggleDrawer(true)} className=''><MenuIcon sx={{ color: '#0000008a', fontSize: '28px'  }} /></Button>
        <Drawer open={open} onClose={toggleDrawer(false)}>
          {DrawerList}
        </Drawer>
      </div>
    );
  }


export default SideBar